import domReady from '@wordpress/dom-ready';
import { render } from '@wordpress/element';
import Slider from 'react-slick';

const App = ( { attributes } ) => {
	const { images, slidesToShow, slidesArrowShow, slidesDotsShow } =
		attributes;

	const settings = {
		dots: slidesDotsShow,
		arrows: slidesArrowShow,
		infinite: true,
		speed: 1000,
		slidesToShow,
		slidesToScroll: 1,
		accessibility: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};

	return (
		<Slider { ...settings }>
			{ images &&
				images?.map( ( image ) => (
					<img key={ image.id } src={ image.url } alt={ image.alt } />
				) ) }
		</Slider>
	);
};

domReady( () => {
	const mountWrap = document.querySelector(
		'.wp-block-do-blocks-image-slider'
	);

	render(
		<App
			attributes={ JSON.parse(
				mountWrap.getAttribute( 'data-attributes' )
			) }
		/>,
		mountWrap
	);
} );
